import React from 'react';
import CustomButton from './CustomButton';
import './theme.css';

class ErrorPage404 extends React.Component {
  /*constructor(props){
    super(props);
    //this.state=
  }*/

  render(){
    return(
      <div className="ablak keret">
        <h1>Error 404 <span role="img" aria-label="error">🛑</span></h1>
        <h2>Page Not Found</h2>
        <CustomButton icon="home" nav url="/" tooltip="Return home"/>
      </div>
    );
  }
}

export default ErrorPage404;



// WEBPACK FOOTER //
// ./src/Component/ErrorPage404.js